import { render, staticRenderFns } from "./PacketCard.vue?vue&type=template&id=159adc14&scoped=true&"
import script from "./PacketCard.vue?vue&type=script&lang=ts&"
export * from "./PacketCard.vue?vue&type=script&lang=ts&"
import style0 from "./PacketCard.vue?vue&type=style&index=0&id=159adc14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159adc14",
  null
  
)

export default component.exports